import { InjectionToken, ValueProvider } from '@angular/core';

export const GIT_HASH_TOKEN = new InjectionToken<string>('GIT_HASH');

export const provideGitHash: (hash: string) => ValueProvider = (hash) => ({
  provide: GIT_HASH_TOKEN,
  useValue: hash,
});
